"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Fig = exports.Conf = exports.Style = void 0;

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.split");

var _index = require("@/lang/index");

var _encryption = require("@/utils/encryption");

// import localStorage from 'js-cookie'
var Style = 'Style';
exports.Style = Style;
var Conf = 'Conf';
exports.Conf = Conf;
var Fig = 'Fig';
exports.Fig = Fig;
var state = {
  sidebar: {
    opened: localStorage.getItem('sidebarStatus') ? !!+localStorage.getItem('sidebarStatus') : true,
    withoutAnimation: false
  },
  device: 'desktop',
  language: (0, _index.getLanguage)(),
  size: localStorage.getItem('size') || 'medium',
  title: '',
  mode: '',
  config: localStorage.getItem(Fig) ? JSON.parse((0, _encryption.decode)(localStorage.getItem(Fig))) : {},
  merchLogo: localStorage.getItem('merch_logo') ? (0, _encryption.decode)(localStorage.getItem('merch_logo')) : '',
  platform: localStorage.getItem(Conf) ? (0, _encryption.decode)(localStorage.getItem(Conf)) : '0-0-0',
  themeConf: localStorage.getItem(Style) ? (0, _encryption.decode)(localStorage.getItem(Style)).split('-')[0] : 'alpha',
  // default: alpha theme
  stripeConf: localStorage.getItem(Style) ? (0, _encryption.decode)(localStorage.getItem(Style)).split('-')[1] : '1',
  // default: table with stripe
  borderConf: localStorage.getItem(Style) ? (0, _encryption.decode)(localStorage.getItem(Style)).split('-')[2] : '0',
  // default: table without border
  plainConf: localStorage.getItem(Style) ? (0, _encryption.decode)(localStorage.getItem(Style)).split('-')[3] : '1',
  // default: button with plain color
  roundConf: localStorage.getItem(Style) ? (0, _encryption.decode)(localStorage.getItem(Style)).split('-')[4] : '1' // default: button with rounded corner

};
var mutations = {
  TOGGLE_SIDEBAR: function TOGGLE_SIDEBAR(state) {
    state.sidebar.opened = !state.sidebar.opened;
    state.sidebar.withoutAnimation = false;

    if (state.sidebar.opened) {
      localStorage.setItem('sidebarStatus', 1);
    } else {
      localStorage.setItem('sidebarStatus', 0);
    }
  },
  CLOSE_SIDEBAR: function CLOSE_SIDEBAR(state, withoutAnimation) {
    localStorage.setItem('sidebarStatus', 0);
    state.sidebar.opened = false;
    state.sidebar.withoutAnimation = withoutAnimation;
  },
  TOGGLE_DEVICE: function TOGGLE_DEVICE(state, device) {
    state.device = device;
  },
  SET_LANGUAGE: function SET_LANGUAGE(state, language) {
    state.language = language;
    localStorage.setItem('language', language);
  },
  SET_SIZE: function SET_SIZE(state, size) {
    state.size = size;
    localStorage.setItem('size', size);
  },
  SET_TITLE: function SET_TITLE(state, title) {
    state.title = title;
  },
  SET_MODE: function SET_MODE(state, mode) {
    state.mode = mode;
  },
  SET_CONFIG: function SET_CONFIG(state, config) {
    state.config = config;
    localStorage.setItem(Fig, (0, _encryption.encode)(JSON.stringify(config)));
  },
  SET_PLATFORM: function SET_PLATFORM(state, platform) {
    state.platform = platform;
    localStorage.setItem(Conf, (0, _encryption.encode)(platform));
  },
  SET_STYLE: function SET_STYLE(state, style) {
    var raw = style.split('-');
    state.themeConf = raw[0];
    state.stripeConf = raw[1];
    state.borderConf = raw[2];
    state.plainConf = raw[3];
    state.roundConf = raw[4];
    localStorage.setItem(Style, (0, _encryption.encode)("".concat(raw[0], "-").concat(+raw[1], "-").concat(+raw[2], "-").concat(+raw[3], "-").concat(+raw[4])));
  },
  SET_MERCH_LOGO: function SET_MERCH_LOGO(state, payload) {
    state.merchLogo = (0, _encryption.decode)(payload);
  }
};
var actions = {
  toggleSideBar: function toggleSideBar(_ref) {
    var commit = _ref.commit;
    commit('TOGGLE_SIDEBAR');
  },
  closeSideBar: function closeSideBar(_ref2, _ref3) {
    var commit = _ref2.commit;
    var withoutAnimation = _ref3.withoutAnimation;
    commit('CLOSE_SIDEBAR', withoutAnimation);
  },
  toggleDevice: function toggleDevice(_ref4, device) {
    var commit = _ref4.commit;
    commit('TOGGLE_DEVICE', device);
  },
  setLanguage: function setLanguage(_ref5, language) {
    var commit = _ref5.commit;
    commit('SET_LANGUAGE', language);
  },
  setSize: function setSize(_ref6, size) {
    var commit = _ref6.commit;
    commit('SET_SIZE', size);
  },
  setTitle: function setTitle(_ref7, title) {
    var commit = _ref7.commit;
    commit('SET_TITLE', title);
  },
  setMode: function setMode(_ref8, mode) {
    var commit = _ref8.commit;
    commit('SET_MODE', mode);
  },
  setConfig: function setConfig(_ref9, arr) {
    var commit = _ref9.commit;
    var result = {};

    for (var i = 0; i < arr.length; i++) {
      if (arr[i]) result[arr[i].code] = arr[i].name;
    }

    commit('SET_CONFIG', result);
    commit('SET_STYLE', result.selectCss);
  },
  setPlatform: function setPlatform(_ref10, platform) {
    var commit = _ref10.commit;
    commit('SET_PLATFORM', platform);
  },
  setStyle: function setStyle(_ref11, style) {
    var commit = _ref11.commit;
    commit('SET_STYLE', style);
  },
  setMerchLogo: function setMerchLogo(_ref12, payload) {
    var commit = _ref12.commit;
    commit('SET_MERCH_LOGO', payload);
  }
};
var _default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};
exports.default = _default;